import React, { FC } from "react";
import { Tooltip, Icon } from "@scuf/common";
import "./OpportunityPage.scss";
import "./OpportunityCellRenderer.scss";
import BlueTick from "../../images/blue-tick.svg";
import GrayTick from "../../images/gray-tick.svg";
import RedTick from "../../images/red-tick.svg";
import YellowTick from "../../images/yellow-tick.svg";
import BarAccepted from "../../images/audit-status-bar-accept.svg";
import BarRejected from "../../images/audit-status-bar-reject.svg";
import ReviewerTraining from "../../images/reviewer-training.svg";
import GetMoreContext from "../../images/get-more-context.svg";
import BusinessAccept from "../../images/successBusiness-accept.svg";
import { useNavigate } from "react-router-dom";
import { RouteConstants } from "../../constants/constants";

import { ACTION_TRACKING_STATUS, USER_ROLE } from "../../constants/constants";
import { setDetailedView } from "src/slices/allOpportunitySlice";
import { useAppDispatch } from "src/store";
import { tagEvent } from "src/utils/analytics/analytics.service.util";

interface TooltipRendererProps {
  content: string;
  imgUrl?: string;
  iconName?: string;
}

const TooltipRenderer: FC<TooltipRendererProps> = ({
  content,
  imgUrl,
  iconName,
}) => {
  return (
    <Tooltip
      content={content}
      element={
        iconName ? (
          <Icon root="common" name={iconName} size="small" color="#D60B13" />
        ) : (
          <img src={imgUrl} alt="tick icon" />
        )
      }
      position="right center"
      event="hover"
      hoverable={true}
    />
  );
};

export const OpportunityCellRenderer = (params: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleViewDetails = () => {
    tagEvent("AnomalyIdClick", { AnomalyId: params.data.insight_id });
    dispatch(setDetailedView("detailed_view"));
    navigate(
      RouteConstants.ANOMALY_DETAILS_RELATIVE_PATH +
        `/${params.data.insight_id}`
    );
  };

  return (
    <>
      <div onClick={handleViewDetails}>
        <div>
          <span className="opportunitycell__audit-status">
            {!(params.data.role_name === USER_ROLE.MODEL_FUNCTIONAL_LEADERSHIP &&
              params.data.role_name === USER_ROLE.MODEL_LABELER &&
              params.data.role_name === USER_ROLE.MODEL_POWER_USER) &&
              params.data.context_flag === "enable context flag" && (
                <TooltipRenderer
                  imgUrl={GetMoreContext}
                  content="Get More Context"
                />
              )}
            {(params.data.role_name === USER_ROLE.VIEWER ||
              params.data.role_name === USER_ROLE.POWER_USER) &&
              (params.data.card_display_status ===
                "Reviewed - Action Assigned" ||
                params.data.insight_display_status ===
                  "reviewed-action_assigned") && (
                <TooltipRenderer
                  imgUrl={ReviewerTraining}
                  content="Training Required"
                />
              )}
          </span>

          <span className="opportunitycell__audit-status">
            {(params.data.role_name === USER_ROLE.REVIEWER &&
              params.data.insight_status === "open" &&
              params.data.audit_latest_status === "audit-reject-reviewer") ||
            (params.data.role_name === USER_ROLE.ORG_USER &&
              (params.data.insight_status === "accepted" ||
                params.data.insight_status === "rejected" ||
                (params.data.insight_module_name === "Project" &&
                  params.data.insight_status === "open")) &&
              params.data.audit_latest_status === "audit-reject-orguser") ||
            ((params.data.role_name === USER_ROLE.POWER_USER ||
              params.data.role_name === USER_ROLE.LEADERSHIP_USER ||
              params.data.role_name === USER_ROLE.DOMAIN_FOCAL) &&
              (params.data.audit_latest_status === "audit-reject-orguser" ||
                params.data.audit_latest_status ===
                  "audit-reject-reviewer")) ? (
              <TooltipRenderer imgUrl={BarRejected} content="Audit Rejected" />
            ) : (
              ""
            )}
            {(params.data.role_name === USER_ROLE.POWER_USER ||
              params.data.role_name === USER_ROLE.LEADERSHIP_USER ||
              params.data.role_name === USER_ROLE.DOMAIN_FOCAL) &&
              (params.data.audit_latest_status === "audit-accept-orguser" ||
                params.data.audit_latest_status ===
                  "audit-accept-reviewer") && (
                <TooltipRenderer
                  imgUrl={BarAccepted}
                  content="Audit Accepted"
                />
              )}
          </span>
          <span className="opportunitycell__business-status">
            {(params.data.role_name === USER_ROLE.REVIEWER &&
              params.data.insight_status === "open" &&
              params.data.business_latest_status ===
                "business-reject-reviewer") ||
            (params.data.role_name === USER_ROLE.ORG_USER &&
              (params.data.insight_status === "accepted" ||
                params.data.insight_status === "rejected" ||
                (params.data.insight_module_name === "Project" &&
                  params.data.insight_status === "open")) &&
              params.data.business_latest_status ===
                "business-reject-orguser") ||
            ((params.data.role_name === USER_ROLE.POWER_USER ||
              params.data.role_name === USER_ROLE.LEADERSHIP_USER ||
              params.data.role_name === USER_ROLE.DOMAIN_FOCAL) &&
              (params.data.business_latest_status ===
                "business-reject-orguser" ||
                params.data.business_latest_status ===
                  "business-reject-reviewer")) ? (
              <TooltipRenderer
                iconName={"badge-info"}
                content="Business Rejected"
              />
            ) : (
              ""
            )}
            {(params.data.role_name === USER_ROLE.POWER_USER ||
              params.data.role_name === USER_ROLE.LEADERSHIP_USER ||
              params.data.role_name === USER_ROLE.DOMAIN_FOCAL) &&
              (params.data.business_latest_status ===
                "business-accept-orguser" ||
                params.data.business_latest_status ===
                  "business-accept-reviewer") && (
                <TooltipRenderer
                  imgUrl={BusinessAccept}
                  content="Business Accepted"
                />
              )}
          </span>
          <span className="allopportunity-link">{params.data.insight_id}</span>
          <span className="opportunitycell__reminders">
            {params.data.recent_activity == "Y" ? "*" : ""}
          </span>
          <span className="oppportunitycell__trackingstatus">
            {params.data.tracking_status ===
              ACTION_TRACKING_STATUS.INCOMPLETE && (
              <TooltipRenderer
                imgUrl={RedTick}
                content="The task is not completed"
              />
            )}
            {params.data.tracking_status ===
              ACTION_TRACKING_STATUS.PARTIALLY_COMPLETE && (
              <TooltipRenderer
                imgUrl={YellowTick}
                content="The task is partially completed"
              />
            )}
            {params.data.tracking_status ===
              ACTION_TRACKING_STATUS.ALL_COMPLETE && (
              <TooltipRenderer
                imgUrl={GrayTick}
                content="Task completed, pending acceptance by Org Owner"
              />
            )}
            {params.data.tracking_status ===
              ACTION_TRACKING_STATUS.ORG_USER_COMPLETE && (
              <TooltipRenderer
                imgUrl={BlueTick}
                content="The anomaly marked completed by Org Owner"
              />
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export const PrevOpportunityCellRenderer: FC<any> = (props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const previous_anomaly_id = props.data?.previous_anomaly_id || null;

  const handleViewDetails = () => {
    tagEvent("AnomalyIdClick", { AnomalyId: previous_anomaly_id });
    dispatch(setDetailedView("detailed_view"));
    navigate(
      RouteConstants.ANOMALY_DETAILS_RELATIVE_PATH + `/${previous_anomaly_id}`
    );
  };

  if (
    !Array.isArray(previous_anomaly_id) ||
    (Array.isArray(previous_anomaly_id) && previous_anomaly_id.length === 0)
  )
    return <span>-</span>;
  return (
    <>
      {previous_anomaly_id.map((anomaly_id: string, i: number) => (
        <>
          <span
            key={anomaly_id}
            className="allopportunity-link"
            onClick={handleViewDetails}
          >
            {anomaly_id}
          </span>
          {previous_anomaly_id.length !== i + 1 && ", "}
        </>
      ))}
    </>
  );
};
